import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const AppointmentService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.APPOINTMENT, null, wait).then((data) => {
            callback(data);
        });
    },
    ListInstructor(callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.APPOINTMENT}/instructor/`, null, wait).then((data) => {
            callback(data);
        });
    },
    ListWeek(callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.APPOINTMENT}/week/`, null, wait).then((data) => {
            callback(data);
        });
    },
    ListWeekInstructor(callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.APPOINTMENT}/instructor/week/`, null, wait).then((data) => {
            callback(data);
        });
    },
    ListWeekStudent(callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.APPOINTMENT}/week/student`, null, wait).then((data) => {
            callback(data);
        });
    },
    GetLiveEducation(isActive, callback, wait) {
        const url = isActive == null
            ? `${Enums.SERVICE.APPOINTMENT}/live-education`
            : `${Enums.SERVICE.APPOINTMENT}/live-education/${isActive}`;

        Ajax.Api(MethodType.Get, url, null, wait).then((data) => {
            callback(data);
        });
    },
    ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.APPOINTMENT}/${id}`, null, wait).then((data) => {
            callback(data);
        });
    },
    Save(j, callback, wait) {
        Ajax.Api((j.id > 0 ? MethodType.Put : MethodType.Post), Enums.SERVICE.APPOINTMENT, j, wait).then((data) => {
            callback(data);
        });
    },
    SaveStudent(j, callback, wait) {
        Ajax.Api(MethodType.Post, `${Enums.SERVICE.APPOINTMENT}/student`, j, wait).then((data) => {
            callback(data);
        });
    },
    SaveInstructorStudent(j, callback, wait) {
        Ajax.Api(MethodType.Post, `${Enums.SERVICE.APPOINTMENT}/instructor/student`, j, wait).then((data) => {
            callback(data);
        });
    },
    Delete(id, isAll, callback) {
        const j = {};
        Ajax.Api(MethodType.Delete, `${Enums.SERVICE.APPOINTMENT}/${id}/${isAll}`, j).then((data) => {
            callback(data);
        });
    },
    DeleteStudent(id, callback) {
        const j = {};
        Ajax.Api(MethodType.Delete, `${Enums.SERVICE.APPOINTMENT}/student/${id}`, j).then((data) => {
            callback(data);
        });
    },
    ListStudentFiles(appointmentId, callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.APPOINTMENT}/student/${appointmentId}/files`, null, wait).then((data) => {
            callback(data);
        });
    },
    SaveStudentFiles(appointmentId, files, callback, wait) {
        Ajax.Api(MethodType.Post, `${Enums.SERVICE.APPOINTMENT}/student/${appointmentId}/files`, { files }, wait).then((data) => {
            callback(data);
        });
    },
    DeleteStudentFile(appointmentId, fileId, callback, wait) {
        Ajax.Api(MethodType.Delete, `${Enums.SERVICE.APPOINTMENT}/student/${appointmentId}/files/${fileId}`, {}, wait).then((data) => {
            callback(data);
        });
    },
};